export default "__VITE_ASSET__6H_HMVcK__"